
import React, {useEffect, useState } from "react"

import styles from "./custom-icon.module.less"
import IosCheckmark from "react-ionicons/lib/IosCheckmark"
import IosClose from "react-ionicons/lib/IosClose"

interface CustomIconProps {
    isChecked: boolean;
    showInvalid?: boolean;
}

const CustomIcon: React.FC<CustomIconProps> = ({ isChecked, showInvalid = false }) => {
    const [checked, setChecked] = useState<boolean>(false);
    const [invalid, setInvalid] = useState<boolean>(false);

    useEffect(() => {
        setChecked(isChecked);
        setInvalid(showInvalid);
    }, [isChecked, showInvalid])

    const getClass = () => {
        if(checked && !invalid){
            return styles.iconWrapperActive;
        }else if(!checked && invalid){
            return styles.iconWrapperInvalid;
        }else{
            return styles.iconWrapper;
        }
    };

    return (
        <div className={getClass()}>
           {checked == true && invalid == false && (<div className={styles.innerIcon}>
                <IosCheckmark fontSize="15px" color="#5cb85c" />
            </div>) }
            {invalid == true && checked == false && (<div className={styles.innerIcon}>
                <IosClose fontSize="15px" color="#d9534f" />
            </div>) }
        </div>
    )
}

export default CustomIcon